import { message } from "antd";
import getVideos from "./getVideos";
import axios from "axios";

export default async function handleAddCourse(course, uid) {
  if (!uid) {
    message.info("Sign in to save this course.");
    return;
  }
  try {
    const items = await getVideos(course.playlistID);
    if (!items.length)
      throw new Error("This playlist has no available lessons.");
    const first = items[0].snippet;
    await axios.post(
      "/api/user/addcourse/uid",
      {
        uid,
        playlistInfo: {
          thumbnail: course.avatar || first.thumbnails?.medium?.url,
          title: course.title,
          playlistID: course.playlistID,
        },
        videos: items.map(({ snippet }) => ({
          videoId: snippet.resourceId.videoId,
          watched: false,
          title: snippet.title,
          description: snippet.description,
        })),
      },
      { timeout: 20000 },
    );
    message.success("Course saved. Find it in My learning.");
  } catch (error) {
    if (error.response?.data?.error === "Playlist already enrolled")
      message.info("This course is already in My learning.");
    else message.error("We couldn’t save this course. Please try again.");
  }
}
